import React, { Component } from 'react';
//import 'fullcalendar/dist/fullcalendar.print.min.css';
import 'fullcalendar/dist/fullcalendar.js';
import {firebaseDb} from '../lib/firebase/firebase';
import {
  formatDate,
  formatTime, 
  validateEmail,
} from '../utils/lib';
var SHA256 = require("crypto-js/sha256");

class ClientForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client:{
        name:'',
        firstName:'',
        lastName:'',
        email:'',
        phone:'',
        gender:'',
        age:'',
        address:'',
        birthdayDay:null,
        birthdayMonth:null,
        birthdayYear:null,
        medicalBackground:'',
        status:'',
        venue:this.props.selectedVenue,
        createdBy:this.props.user?this.props.user.id:null,
        createdAt:'',        
      },
    };
  }

  componentDidMount(){
    var _self = this;
    if(this.props.clientId){
      firebaseDb.ref("clients/" + this.props.clientId).on('value',function(snap){
        _self.setState({reservation:snap.val()})
      })
    }
  }
  componentWillUnmount(){
  }
  handleChangeInput(field,event) {
    var client = this.state.client;
    client[field] = event.target.value;
    this.setState({client});
  }

  getDays(){
    var items = [];
    for (var i = 1; i < 32; i++) {
      var d = i;
      if(i<10){
        d = '0' + i.toString()
      }
      items.push(
        <option key={d} value={i}>{d}</option>
      );
    }
    items.unshift(
      <option key={'label'} value={null}>Day</option>
    );
    return items;
  }
  getMonths(){
    var items = [];
    for (var i = 1; i < 12; i++) {
      var d = i;
      if(i<10){
        d = '0' + i.toString()
      }
      items.push(
        <option key={d} value={i-1}>{d}</option>
      );
    }
    items.unshift(
      <option key={'label'} value={null}>Month</option>
    );
    return items;
  }
  getYears(){
    var items = [];
    for (var i = parseInt((new Date()).getFullYear())-150; i <= parseInt((new Date()).getFullYear()); i++) {
      var d = i;
      items.unshift(
        <option key={d} value={d}>{d}</option>
      );
    }
    items.unshift(
      <option key={'label'} value={null}>Year</option>
    );
    return items;
  }

  clearForm(){
    this.setState({
      client:{
        name:'',
        firstName:'',
        lastName:'',
        email:'',
        phone:'',
        gender:'',
        age:'',
        address:'',
        birthdayDay:null,
        birthdayMonth:null,
        birthdayYear:null,
        medicalBackground:'',
        status:'',
        venue:this.props.selectedVenue,
        createdBy:this.props.user?this.props.user.id:null,
        createdAt:'',        
      },
    },this.props.onClear);
  }

  handleCreateClick(){
    var isValid = this.validateClient();
    if(isValid.valid){
      if(this.props.clientId){
        var client_id = this.props.clientId;
      }else{
        var client_id = SHA256( this.props.selectedVenue + this.state.client.email ).toString();
      }
      firebaseDb.ref("clients/" + client_id).set(this.state.client);
      firebaseDb.ref("venues/"+this.props.selectedVenue+"/clients/"+client_id).set(true);
      this.setState({message:{type:"success",text:"Reservation created successfully!"}},this.clearForm.bind(this))
      var data = this.state.client;
      data['id'] = client_id;
      this.props.onCreate(data);
    }else{
      this.setState({message:{type:"danger",text:isValid.message}})
    }
  }

  validateClient(){
    if(this.state.client.email==="" || !validateEmail(this.state.client.email))
      return {valid:false,message:'Invalid email.'};
    if(this.state.client.name==="")
      return {valid:false,message:'Invalid name.'};
    if(this.state.client.phone==="")
      return {valid:false,message:'Invalid phone.'};

    return {valid:true,}
  }

  render() {
    var days = this.getDays()
    var months = this.getMonths()
    var years = this.getYears()
    return(
      <div>
        <div className="row">
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">Name</label>
              <input className="form-control" type="text" value={this.state.client.name} onChange={this.handleChangeInput.bind(this,'name')}/>
            </div>
          </div>
          <div className="col-sm-6 col-xs-12">
            <div className="form-group">
              <label className="control-label">Email</label>
              <input className="form-control" type="text" value={this.state.client.email} onChange={this.handleChangeInput.bind(this,'email')}/>
            </div>
          </div>
          <div className="col-sm-6 col-xs-12">
            <div className="form-group">
              <label className="control-label">Phone</label>
              <input className="form-control" type="text" value={this.state.client.phone} onChange={this.handleChangeInput.bind(this,'phone')}/>
            </div>
          </div>
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">Address</label>
              <input className="form-control" type="text" value={this.state.client.address} onChange={this.handleChangeInput.bind(this,'address')}/>
            </div>
          </div>
          <div className="col-md-4 col-sm-12">
            <label>Gender</label>
            <div className="form-group">
              <select value={this.state.client.gender} onChange={this.handleChangeInput.bind(this,'gender')} className="form-control">
                <option value={'female'}>Female</option>
                <option value={'male'}>Male</option>
                <option value={'no specified'}>No specified</option>
              </select>
            </div>
          </div>
          <div className="col-md-8 col-sm-12">
            <label>Birthday</label>
            <div className="row">
              <div className="col-xs-4">
                <div className="form-group">
                  <select value={this.state.client.birthdayYear} onChange={this.handleChangeInput.bind(this,'birthdayYear')} className="form-control">
                    {years}
                  </select>
                </div>
              </div>
              <div className="col-xs-4">
                <div className="form-group">
                  <select value={this.state.client.birthdayMonth} onChange={this.handleChangeInput.bind(this,'birthdayMonth')} className="form-control">
                    {months}
                  </select>
                </div>
              </div>
              <div className="col-xs-4">
                <div className="form-group">
                  <select value={this.state.client.birthdayDay} onChange={this.handleChangeInput.bind(this,'birthdayDay')} className="form-control">
                    {days}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12">
            <div className="form-group">
              <label className="control-label">Medical Background</label>
              <textarea className="form-control" rows="5" onChange={this.handleChangeInput.bind(this,'medicalBackground')} value={this.state.client.medicalBackground}></textarea>
            </div>
          </div>
          <div className="col-xs-12">
            {this.state.text}
            <a onClick={this.clearForm.bind(this)} className="btn btn-default pull-right">Clear</a>
            <a onClick={this.handleCreateClick.bind(this)} className="btn btn-primary"><span className="glyphicon glyphicon-plus" aria-hidden="true"></span> Create</a>
          </div>
        </div>
      </div>
    );   
  }
}
// Specifies the default values for props:
ClientForm.defaultProps = {
  selectedDateRange:{
    start:"",
    end:"",
  },
  onClear:()=>console.log('Clear form'),
  onCreate:()=>console.log('Create form'),
}
export default ClientForm;


// WEBPACK FOOTER //
// ./src/components/ClientForm.js